module.exports = __webpack_public_path__ + "img/secure-blue.59572e7b.svg";